import React from 'react';
import PropTypes from 'prop-types';
import { MainContent, ContentBox, ContenFooter,ContentHeading, MainArea } from '../styles';

const propTypes = {
  actionBar: PropTypes.node,
  heading: PropTypes.node,
  footer: PropTypes.node,
  children: PropTypes.node,
  transparent: PropTypes.bool,
  overflow: PropTypes.bool
};

const noMarginClass = {
  marginLeft: 0,
  marginRight: 0
}
function PageContent({ actionBar, footer, children,className, transparent, overflow, heading, mainAreaOverflow, noHorizontalMargin }) {
  return (
    <MainContent className={className ? `${className}__MainContent`:''} transparent={transparent}>
       <ContentBox className={className ? `${className}__ContentBox`:''} overflow={overflow}>
        {heading && <ContentHeading>{heading}</ContentHeading>}
        <MainArea className={`main-content-wrapper` + (className ? `${className}__MainArea`:'')} style={noHorizontalMargin? noMarginClass: {}} transparent={transparent} overflow={mainAreaOverflow}>
          {actionBar}
          {children}
          {footer && <ContenFooter>{footer}</ContenFooter>}
        </MainArea>
      </ContentBox>
    </MainContent>
  );
}

PageContent.propTypes = propTypes;

export default PageContent;



// WEBPACK FOOTER //
// src/modules/theme/theme1/layout/components/PageContent.js